module.exports = __webpack_public_path__ + "img/3ds-max.892ae4dc.png";